/**
 * Initialize the Walls Helper Namespace
 */
if (typeof(Walls) === 'undefined') {
    var Walls = {};
}

Walls.UserCred = {
    /**
     * WRS Cred Configuration
     */
    name:      '974e-43e8-90da-c775bc399cc2',
    cred:      '9691-4640-89f3'
}

Walls.API = {

    /**
     * WRS API Configuration
     */
    cateryst_endpoint_base: 'https://caterlyst.com/API/Company/Search?query=',
    username:      '3d737b2f-'+Walls.UserCred.name,
    password:      '106f3cd5-'+Walls.UserCred.cred+'-8884fe59a51f'
}  
